module.exports = __webpack_public_path__ + "media/images/Group 14-cbc608feda9c0db1a2eeb390d7baf5b9.png";